import getCaretCoordinates from "textarea-caret";

export function getCaretPositionFromCoordinates(input: HTMLInputElement, targetX: number) {
  const textLength = input.value.length;
  let start = 0;
  let end = textLength;

  let closestPos = 0;
  let closestDistance = Infinity;

  while (start <= end) {
    const mid = Math.floor((start + end) / 2);
    // TODO: this function recreates mirroring div with each call
    // optimize by reusing the same div
    const { left: x } = getCaretCoordinates(input, mid);

    const distance = Math.abs(x - targetX);

    if (distance < closestDistance) {
      closestDistance = distance;
      closestPos = mid;
    }

    if (x <= targetX) {
      start = mid + 1;
    } else {
      end = mid - 1;
    }
  }

  return closestPos;
}
